<template>
    <div class="wrapper">
        <div class="padding-sm bg-white flex-sub">
            <div class="flex align-center justify-between margin-bottom-sm page-title">
                <b>暖心服务-{{ type | typeTitle }}</b>
               <div class="flex align-center">
                   <el-button round type="primary" @click="sendSms(false)">全部发送通知</el-button>
                   <el-button class="blue-btn" round type="primary" @click="$router.go(-1)">返回
                   </el-button>
               </div>
            </div>
            <div class="flex align-center justify-between margin-bottom-sm list-search">
                <el-select v-model="organiz_id" class="margin-right-sm flex-shrink" placeholder="请选择所属协会">
                    <el-option
                        v-for="item in organizList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
                <el-select v-model="level" class="margin-right-sm flex-shrink" placeholder="请选择会员等级">
                    <el-option
                        v-for="item in levelList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
                <el-input
                    v-model="keyWord"
                    placeholder="请输入单位名称/会员姓名/联系电话"
                ></el-input>
                <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
            </div>
            <div class="ship-list">
                <el-table
                    v-loading="loading"
                    :data="lists" border
                    header-row-class-name="table-header"
                    style="width: 100%; border-radius: 10px">
                    <el-table-column
                        label="序号"
                        type="index"
                        width="50">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.$index + 1 }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="单位名称/会员姓名" prop="company" width="180px">
                        <template slot-scope="scope">
                            <div class="table-name"> {{ scope.row.user_type === 1 ? scope.row.company : scope.row.name
                                }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="所属协会" prop="company" width="180px">
                        <template slot-scope="scope">
                            <div class="table-name"> {{ scope.row.org_name || user.morgname }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="联系人" prop="name">
                        <template slot-scope="scope">
                            <div class="table-name"> {{ scope.row.name }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="手机号" prop="phone" width="110px">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.phone }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="会员等级" prop="rank_name">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.rank_name }}
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column label="到期时间" prop="end_time" v-if="type === 1">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.end_time | setTime }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="参与时间" prop="rank_name" v-else-if="type === 2">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.signtime }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="入会时间" prop="reg_time" v-else-if="type === 3">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.reg_time | setDate }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="出生日期" prop="birthday" v-else>
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.birthday }}
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作" width="120px">
                        <template slot-scope="scope">
                            <div class="flex justify-center  align-center">
                                <el-button type="text" @click="toDetail(scope.row)">查看</el-button>
                                <el-button type="text" class="text-red" @click="sendSms(scope.row)">发送通知</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!--            <el-pagination-->
            <!--                :current-page.sync="page"-->
            <!--                :page-size="limit"-->
            <!--                :total="total"-->
            <!--                background-->
            <!--                class="page-all margin-top"-->
            <!--                layout="prev, pager, next, jumper"-->
            <!--                @current-change="getCheckList">-->
            <!--            </el-pagination>-->
        </div>
        <heart-sms-dialog :type="type" :dialogVisible="dialogVisible" :members="members" @watchState="watchState"></heart-sms-dialog>
    </div>
</template>

<script>
import {getRankList, getServiceList,} from "@/api/organiz";
import {getUser, zhDate} from "@/utils/utils";
import {getfenhuiList} from "@/api/login";
import HeartSmsDialog from "@/views/organization/components/HeartSmsDialog";

export default {
    name: "heart",
    data() {
        return {
            type: 0,
            levelList: [{
                id: 0,
                name: "全部"
            }],
            organizList: [{
                id: -1,
                name: "全部"
            }, {
                id: 0,
                name: getUser().morgname
            }],
            organiz_id: '',
            level: '',
            keyWord: '',
            lists: [],
            page: 1,
            limit: 15,
            total: 0,
            loading: false,

            dialogVisible: false,
            members: []
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
        this.$emit('setIndex', [0, 0], '首页-暖心服务')
        this.type = Number(this.$route.params.type || 0)
        this.getServiceList()
        // 级别管理下拉列表
        this.getRankList()
    },
    components: {HeartSmsDialog},
    methods: {
        toDetail(item) {
            this.$router.push(`/organization/members/info/${item.user_id}/${item.user_type}`)
        },
        sendSms(data) {
            this.members = data ?  [data] : this.lists
            this.dialogVisible = true
        },
        watchState() {
            this.members = []
            this.dialogVisible = false
            this.getServiceList()
        },
        search() {
            this.page = 1
            this.getServiceList()
        },
        // 获取等级
        async getServiceList() {
            let _list = await getServiceList(this.type, this.level, this.organiz_id === -1 ? '' : this.organiz_id, this.keyWord)
            this.lists = _list.data
            this.total = _list.count
        },
        //  获取等级列表
        async getRankList() {
            let _list = await getRankList()
            this.levelList = [...this.levelList, ..._list.data]
            let _data = await getfenhuiList(this.user.mid)
            this.organizList = [...this.organizList, ..._data.data]
        },
    },
    filters: {
        setTime(val) {
            return zhDate(new Date(val * 1000))
        },
        setDate(val) {
            return zhDate(new Date(val))
        },
        typeTitle(val) {
            switch (Number(val)) {
                case 1:
                    return '会费到期'
                case 2:
                    return '答谢参与'
                case 3:
                    return '祝贺入会'
                case 4:
                    return '待审批'
                case 5:
                    return '生日提醒'

            }
        }
    },
}
</script>

<style lang="scss" scoped>
.wrapper {
    .min-height {
        min-height: 930px;
    }

    .classifys {
        margin-bottom: 20px;

        .classify {
            width: 120px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            border: 1px solid #ffb400;
            color: #ffb400;
            border-radius: 0 6px 6px 0;

            &.active {
                background: #ffb400;
                color: #FFFFFF;
                border-radius: 6px 0 0 6px;
            }
        }
    }

    .member-set {
        div {
            width: 171px;
            height: 50px;
            text-align: center;
            line-height: 50px;
            background-color: #f3f7fb;
            border-radius: 10px;
            border: solid 1px #dae0e6;
            font-size: 18px;
            cursor: pointer;

            &:hover {
                background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                linear-gradient(#0a2240, #0a2240);
                background-blend-mode: normal, normal;
                color: #fff;
            }
        }
    }

    .list-search {
        .el-button {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            background: #0a2240;
            border: 0;
            font-size: 16px;
        }
    }

    .table-name {
        font-size: 14px;
        color: #333333;
        text-align: center;

        &.gray {
            color: #999999;
        }
    }

    .table-operate {
        width: 60px;
        height: 30px;
        padding: 0;
        border-radius: 15px;
        background-color: #0a2240;
        border: solid 1px #0a2240;
        font-size: 14px;
        color: #ffffff;

        &.line {
            background-color: #ffffff;
            color: #0a2240;
        }

        &:disabled {
            background-color: #ffffff;
            border: solid 1px #dae0e6;
            color: #bcc6cf;
        }
    }
}
</style>
